'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

RemoteProgressDirective=class RemoteProgressDirective extends BaseControllerBackedDirective{
get textBindings(){
return['handlerName','handlerNames'];
}

get templateUrl(){
return'/templates/directives/remoteProgressDirective/remoteProgressTemplate';
}

get controller(){
return RemoteProgressDirectiveController;
}};


const _cubicEasing=t=>t*t*t;let

RemoteProgressDirectiveController=class RemoteProgressDirectiveController{
constructor(progressService,$scope){
this._progressService=progressService;
this._$scope=$scope;

if(this.handlerName&&this.handlerNames){
throw new Error('Cannot have both handlerName and handlerNames at the same time. Either pick singular or plural');
}

this._watchedNames=this.handlerName?[this.handlerName]:this.handlerNames.split(/\s*,\s*/g);

this._debouncedDisable=_.debounce(()=>{
if(!this._isVisible||this.value!==100){
return;
}
this._$scope.$evalAsync(()=>this._isVisible=!1);
},400);
}

get isVisible(){
return this._isVisible;
}

get value(){
const _reduced=this._watchedNames.reduce((sum,val)=>sum+_.get(this._progressService.currentProgress,val,0),0)/this._watchedNames.length;
const _eased=_cubicEasing(_reduced);
const _scaled=_eased*100;

if(this._isVisible&&_scaled==100){
this._debouncedDisable();
}else if(this._isVisible&&_scaled==0){
this._$scope.$evalAsync(()=>this._isVisible=!1);
}else if(!this._isVisible&&_scaled>0&&_scaled<100){
this._$scope.$evalAsync(()=>this._isVisible=!0);
}

return _scaled;
}};



module.exports=RemoteProgressDirective;
//# sourceMappingURL=remoteProgressDirective.js.map
